<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" v-show="showSearch">
      <el-form-item prop="iccid">
        <el-input
          v-model="queryParams.iccid"
          placeholder="请输入ICCID"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
        />
      </el-form-item>
      <el-form-item  prop="operationType">
        <el-select v-model="queryParams.operationType" 
        placeholder="请选择类型" 
        style="width: 240px" 
        clearable
        @change="search"
        >
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item  prop="operationStatus">
        <el-select v-model="queryParams.operationStatus" 
        placeholder="请选择状态" 
        style="width: 240px" 
        clearable
        @change="search"
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 展示待处理信息条数 -->
    <div v-if="pendingCount > 0" class="pending-count">
      处理中: <span class="pending-count-number">{{ pendingCount }}</span>
    </div>
    <el-table v-loading="loading" :data="tableData" border>
      <el-table-column fixed  label="ICCID" prop="iccid" align="center" width="220" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="jumpButton(scope.row)">{{ scope.row.iccid }}</el-link>
          </template>
      </el-table-column>
      <el-table-column prop="operationType" label="类型" align="center"  width="160" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="operationStatus" label="状态" align="center"  width="160" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="reqReason" label="请求原因" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="failReason" label="失败原因" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="channel" label="通道" align="center"  width="160" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="reqCount" label="请求次数" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="finishTime" label="完成时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.finishTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createId" label="操作人" align="center" min-width="160"></el-table-column>
      <el-table-column prop="outReqId" label="业务号" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    ></pagination>
  </div>
</template>

<script>
import {cardOperationPage , cardOperationCount} from "@/api/card";
import {cardOperationType} from "@/api/api";
export default {
  name:'recordOperation',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 搜索
      queryParams:{
        userId:undefined,
        iccid:undefined,
        missionId:undefined,
        status:undefined,
      },
      statusList:[
          {
            value:0,
            label:'待处理'
          },
          {
            value:1,
            label:'处理中'
          },
          {
            value:2,
            label:'处理成功'
          },
          {
            value:3,
            label:'处理失败'
          },
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      types:[],
      pendingCount: 0 // 待处理信息条数
    };
  },
  methods: {
    initData() {
      this.loading = true;
      let params = {
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      cardOperationPage(params).then(res => {
        this.loading = false;
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    initTypes(){
      cardOperationType().then(res=>{
        this.types = res.data.data
      })
    },
    initCount(){
      cardOperationCount().then(res=>{
        this.pendingCount = res.data.data
      })
    },
    // 页面跳转
    handleClick(routerPath){
      this.$router.push(routerPath);
    },
    /** 搜索按钮操作 */
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    jumpButton(row){
      if(row.channel == 'cmlink' || row.channel == 'multi' || row.channel == 'cmBrazil'){
          this.$router.push({path:"/international/internationalDetail",query:{iccid: row.iccid}});
      }else{
        this.$router.push({path:"/card/detail",query:{iccid: row.iccid}});
      }
    },
  },
  created() {
    this.initTypes()
    this.initData()
    this.initCount()
  }
};
</script>

<style scoped lang="less">
.pending-count {
  margin-bottom: 10px;
  color: #606266;
  font-size: 16px;
  .pending-count-number {
    color: #f56c6c; /* 红色 */
    font-weight: bold; /* 加粗 */
  }
}
</style>